
export { DataCatalogType } from "/codebuild/output/src4258496796/src/actions-runner/_work/eon-service/eon-service/frontend/packages/api-gw-sdk/dist/models/DataCatalogType.js"